import React, { useContext, useEffect, useState } from 'react';
import { translate } from 'react-multi-lang';
import { Alert, } from 'antd';
import locale_ca from 'antd/es/date-picker/locale/ca_ES';

import DashboardAdmin from './perfils/admin/Dashboard';
import DashboardPares from './perfils/pares/Dashboard';

import { PerfilUsuariContext } from "../context/perfil-usuari";
import { Api } from '../helpers';

function Dashboard(props){
  const [perfilUsuari, setPerfilUsuari] = useContext(PerfilUsuariContext);
  const [nomes_bus, setNomes_bus] = useState(perfilUsuari.nomes_bus);

  switch (perfilUsuari.account.perfil) {
    case "Pare":
    case "Professor":
      return (<DashboardPares/>);
      break;
    case "EmpresesAdmin":
      return (<DashboardAdmin/>);
      break;
    default:
      return(
        <div style={{padding: '1rem'}}>
        <Alert
        message="Error"
        description="Usuario incorrecto o datos de usuario corruptos. Pongase en contacto con administración."
        type="error"
        showIcon
        />
        </div>
      );
  }

}

export default translate(Dashboard);
